import { compose } from 'recompose';

import VariantsList from './VariantsList';

const enhance = compose();

export default enhance(VariantsList);
